module.exports = __webpack_public_path__ + "a28d209e365d5b7d90d77d1a8c78338c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/GT-Eesti-Text-Medium.ttf
// module id = 43
// module chunks = 0